// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___dcbbv";
var _2 = "styles-module__icon___SI4hr";
var _3 = "styles-module__shareDrawer___aoC_X";
var _4 = "styles-module__shareImageContainer___fkV5O";
var _5 = "styles-module__successImage___e4G0E";
var _6 = "styles-module__title___Rz2BF";
export { _1 as "container", _2 as "icon", _3 as "shareDrawer", _4 as "shareImageContainer", _5 as "successImage", _6 as "title" }
